<template>
      <div class="col-md-6">
          <div class="card">
              <div class="card-header bg-transparent text-left">
                <strong>Grupos mais vendidos no(s) ultimo(s) {{periodText}}</strong>
              </div>

              <div class="card-body">
                  <sales-group 
                    :period="period"
                  />
              </div>

              <div class="card-footer bg-transparent text-left" >
                  <div class="row" >
                      <div class="col-md-8" >
                          
                      </div>
                      <div class="col-md-4" >
                        <div class="btn-group" role="group" aria-label="Basic example">
                          <button type="button" v-bind:class="[active ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 7, active = true]" class="btn btn-sm">7 Dias</button>
                          <button type="button" v-bind:class="[!active ? 'btn-primary' : 'btn-secondary', 'btn-primary']" @click.prevent="[period = 0, active = false]"  class="btn btn-sm">Hoje</button>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>   
</template>
<script>
    import salesGroup from '@/components/graphs/salesGroup.vue'
    export default {
        name: 'homeSalesGroup',
        components:{
          salesGroup
        },
  data(){
    return {
      active: true,
      period: 7,
      periodText: '7 Dias'
    }
  },
  watch: {
    period: function(newVal, oldVal){
      if(newVal == 7){
        this.periodText = '7 Dias'
      }else{
        this.periodText = 'Hoje'
      }
    }
  }       
    }
</script>